"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRowTwoCol = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var IE11StyledRowTwoCol = _styledComponents.default.div.withConfig({
  displayName: "RowTwoColstyles__IE11StyledRowTwoCol",
  componentId: "vzckbk-0"
})(["display:-ms-grid;-ms-grid-columns:1fr ", " 1fr;.c-row-two-col-left-content{-ms-grid-column:1;text-align:left;}.c-row-two-col-right-content{-ms-grid-column:3;}"], function (props) {
  return props.theme.twoColSpacing;
});

var StyledRowTwoCol = (0, _styledComponents.default)(IE11StyledRowTwoCol).withConfig({
  displayName: "RowTwoColstyles__StyledRowTwoCol",
  componentId: "vzckbk-1"
})(["@supports (display:grid){&{display:grid;grid-template-columns:1fr ", " 1fr;grid-template-areas:\"lc . rc\";}.c-row-two-col-left-content{grid-area:lc;text-align:left;}.c-row-two-col-right-content{grid-area:rc;}}"], function (props) {
  return props.theme.twoColSpacing;
});
exports.StyledRowTwoCol = StyledRowTwoCol;